module.exports = __webpack_public_path__ + "static/img/four.fb59a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gRDImg/four.png
// module id = Rcnc
// module chunks = 1